/* FW_META_ATTRIBUTION_CAPTURE_V3_SCRIPTTAG: Shopify ScriptTag capture for Meta offline attribution + FW_VISITOR_ID_V4 (2026-09-05) */
(function(){
  if (window.__FW_META_ATTRIBUTION_CAPTURE_V3__) return;
  window.__FW_META_ATTRIBUTION_CAPTURE_V3__ = true;
  try {
    var params = new URLSearchParams(window.location.search || '');
    var fbclid = params.get('fbclid') || '';
    var now = Math.floor(Date.now()/1000);
    function esc(s){return s.replace(/([.$?*|{}()\[\]\\\/\+^])/g,'\\$1');}
    function getCookie(n){var m=document.cookie.match(new RegExp('(?:^|; )'+esc(n)+'=([^;]*)'));return m?decodeURIComponent(m[1]):'';}
    function setCookie(n,v){if(v==='')return;document.cookie=n+'='+encodeURIComponent(v)+'; path=/; max-age=7776000; SameSite=Lax';}
    function delCookie(n){document.cookie=n+'=; path=/; max-age=0; SameSite=Lax';}
    var fbp=getCookie('_fbp');
    if(!fbp){fbp='fb.1.'+Date.now()+'.'+Math.floor(Math.random()*1000000000);setCookie('_fbp',fbp);}
    var fbc=getCookie('_fbc');
    if(fbclid&&!fbc){fbc='fb.1.'+now+'.'+fbclid;setCookie('_fbc',fbc);}

    /* Google Ads appends our final_url_suffix onto the Merchant Center feed link instead of replacing it,
       so utm_* keys repeat: free-listing pair first, paid pair second. Taking the first occurrence
       misreports paid clicks as organic, so select the paid occurrence positionally. */
    var utmSrc=params.getAll('utm_source'), utmMed=params.getAll('utm_medium'), utmCam=params.getAll('utm_campaign');
    var utmIdx=-1;
    for(var i=0;i<utmMed.length;i++){var m=String(utmMed[i]).toLowerCase();if(m==='cpc'||m==='ppc'||m==='paid'){utmIdx=i;break;}}
    if(utmIdx<0){utmIdx=Math.max(utmSrc.length,utmMed.length,utmCam.length)-1;}
    function pickUtm(a){return (utmIdx>=0&&utmIdx<a.length)?a[utmIdx]:'';}
    var utm={utm_source:pickUtm(utmSrc),utm_medium:pickUtm(utmMed),utm_campaign:pickUtm(utmCam)};
    var fresh=!!(utm.utm_source||utm.utm_medium||utm.utm_campaign);

    /* Delivery used to be fire-and-forget, so a dropped landing-page request lost the utm permanently:
       later pages carry no utm in the URL to recover it from. Persist the landing values before any
       network call, and keep retrying until the cart is observed to hold them. Only a pageview that
       itself carries utm may overwrite prior attribution; a plain pageview never clears it. */
    if(fresh){
      setCookie('fw_utm',JSON.stringify(utm));
      delCookie('fw_utm_ok');
    } else {
      var stored=getCookie('fw_utm');
      if(stored){try{var s=JSON.parse(stored);utm={utm_source:s.utm_source||'',utm_medium:s.utm_medium||'',utm_campaign:s.utm_campaign||''};}catch(e){}}
    }
    var haveUtm=!!(utm.utm_source||utm.utm_medium||utm.utm_campaign);
    var confirmed=getCookie('fw_utm_ok')==='1';

    var attrs={attributes:{}};
    function putAttr(k,v){if(typeof v==='string'&&v!==''){attrs.attributes[k]=v;}}
    putAttr('_fbp',fbp);putAttr('_fbc',fbc);putAttr('fbclid',fbclid);
    putAttr('utm_source',utm.utm_source);putAttr('utm_medium',utm.utm_medium);putAttr('utm_campaign',utm.utm_campaign);

    /* FW_VISITOR_ID_V4 (Master Plan B1, 2026-09-05): first-party visitor id.
       UUIDv4 in a 13-month cookie + localStorage mirror; written as hidden cart attribute _fw_vid
       (underscore = never shown to the customer) and posted with a few intent events to
       fw-api.furnitureworld.co.nz/identity. No third-party identity vendors; identity is only
       ever what the shopper types in later (forms, checkout). */
    function uuid4(){
      if(window.crypto&&crypto.randomUUID) return crypto.randomUUID();
      var b=new Uint8Array(16);(window.crypto||{}).getRandomValues?crypto.getRandomValues(b):b.forEach(function(_,i){b[i]=Math.floor(Math.random()*256);});
      b[6]=(b[6]&0x0f)|0x40;b[8]=(b[8]&0x3f)|0x80;
      var h=Array.prototype.map.call(b,function(x){return ('0'+x.toString(16)).slice(-2);}).join('');
      return h.slice(0,8)+'-'+h.slice(8,12)+'-'+h.slice(12,16)+'-'+h.slice(16,20)+'-'+h.slice(20);
    }
    var vid='';
    try{vid=getCookie('fw_vid')||localStorage.getItem('fw_vid')||'';}catch(e){vid=getCookie('fw_vid')||'';}
    if(!/^[0-9a-f-]{36}$/i.test(vid)){vid=uuid4();}
    document.cookie='fw_vid='+vid+'; path=/; max-age=34128000; SameSite=Lax; Secure';
    try{localStorage.setItem('fw_vid',vid);}catch(e){}
    window.__FW_VID__=vid;
    putAttr('_fw_vid',vid);

    /* intent events: page/product/collection/search only; ATC + estimator + checkout are
       observed on the server side (cart attribute + abandoned-checkout + order). */
    var fwEvents=[];
    var path=location.pathname||'';
    var pv={event:'page_view'};
    if(/^\/products\//.test(path)){
      pv.event='product_view';
      var pm=document.querySelector('meta[property="og:image"]');
      var pidEl=document.querySelector('[data-product-id]')||document.querySelector('form[action*="/cart/add"] [name="product-id"]');
      pv.product_id=(pidEl&&(pidEl.getAttribute('data-product-id')||pidEl.value))||'';
      var vp=new URLSearchParams(location.search).get('variant');if(vp)pv.variant_id=vp;
    } else if(/^\/collections\//.test(path)){pv.event='collection_view';pv.meta={h:path.split('/')[2]||''};}
    else if(/^\/search/.test(path)){pv.event='search';pv.meta={q:(new URLSearchParams(location.search).get('q')||'').slice(0,80)};}
    else if(/finance/.test(path)){pv.event='finance_view';}
    fwEvents.push(pv);
    try{
      var ep='https://fw-api.furnitureworld.co.nz/identity/event';
      var body=JSON.stringify({vid:vid,events:fwEvents});
      if(navigator.sendBeacon){navigator.sendBeacon(ep,new Blob([body],{type:'application/json'}));}
      else if(typeof fetch==='function'){fetch(ep,{method:'POST',headers:{'Content-Type':'application/json'},body:body,keepalive:true,mode:'cors',credentials:'omit'}).catch(function(){});}
    }catch(e){}
    /* variant change → one event, debounced */
    try{
      var vt=null;
      document.addEventListener('change',function(ev){
        var t=ev.target;if(!t||!/^\/products\//.test(path))return;
        if(t.name==='id'||/option|variant|fabric|colour|color/i.test(t.name||'')){
          clearTimeout(vt);vt=setTimeout(function(){
            var b2=JSON.stringify({vid:vid,events:[{event:'variant_select',product_id:pv.product_id||'',variant_id:(document.querySelector('form[action*="/cart/add"] [name="id"]')||{}).value||''}]});
            if(navigator.sendBeacon)navigator.sendBeacon('https://fw-api.furnitureworld.co.nz/identity/event',new Blob([b2],{type:'application/json'}));
          },800);
        }
      },true);
    }catch(e){}
    if(!Object.keys(attrs.attributes).length) return;
    attrs.attributes.fw_meta_attr_version='v4_confirmed';
    var payload=JSON.stringify(attrs);

    if(typeof fetch!=='function'){
      if(navigator.sendBeacon) navigator.sendBeacon('/cart/update.js', new Blob([payload],{type:'application/json'}));
      return;
    }

    /* /cart/update.js returns the updated cart, so persistence is verified from the write response
       itself — a 2xx alone is not proof the attributes landed. No extra read request is needed. */
    function send(){
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:payload,keepalive:true,credentials:'same-origin'})
        .then(function(r){
          if(!r.ok) return {ok:false,rateLimited:r.status===429};
          return r.json().then(function(c){return {ok:true,cart:c};},function(){return {ok:true,cart:null};});
        })
        .catch(function(){return {ok:false,rateLimited:false};});
    }
    function landed(res){
      var a=res.ok&&res.cart&&res.cart.attributes;
      if(!a) return false;
      for(var k in attrs.attributes){if(a[k]!==attrs.attributes[k])return false;}
      return true;
    }

    send().then(function(res){
      if(landed(res)){if(haveUtm) setCookie('fw_utm_ok','1');return;}
      if(confirmed) return;
      if(res.rateLimited) return;
      return new Promise(function(r){setTimeout(r,900);})
        .then(send)
        .then(function(res2){if(landed(res2)) setCookie('fw_utm_ok','1');});
    });
  } catch(e) {}
})();
